import { normalizeString } from "./normalizeString";
import moment, { Moment } from "moment";

export function compare<T extends string | number | Date | Moment>(a: T, b: T) {
  if (typeof a === "string" && typeof b === "string")
    return normalizeString(a).localeCompare(normalizeString(b));
  if (typeof a === "number" && typeof b === "number") return a - b;
  if (a instanceof Date && b instanceof Date) return a.getTime() - b.getTime();
  if (moment.isMoment(a) && moment.isMoment(b)) return a.diff(b);
  return 0;
}
